/**
 * Helpers for rendering assistant citation markdown as superscript indices.
 */

/**
 * Pick a short numeric token from the citation link label for bracket display (superscript).
 *
 * Precedence:
 * 1. Parenthetical `(digits)` at the **end** of the label (after optional whitespace).
 * 2. Else the **last** parenthetical `(digits)` anywhere in the label.
 * 3. Else the **first** run of ASCII digits in the label.
 * 4. Else `·` when there are no digits (including empty / whitespace-only labels).
 */
export function extractCitationIndex(label: string): string {
  const trailing = /\((\d+)\)\s*$/.exec(label);
  if (trailing) return trailing[1];

  const all = [...label.matchAll(/\((\d+)\)/g)];
  if (all.length > 0) return all[all.length - 1][1];

  const digitRun = /\d+/.exec(label);
  return digitRun ? digitRun[0] : "·";
}
